import { Country } from "../model/Country";

export const filterCountriesByCountryCode = (countries: Country[], countryCode: string): Country[] => {
    return countries.filter(country => {
        return country.ggsCountryCode.toLowerCase() === countryCode.toLowerCase();
    });
};

export const filterCountriesByGeoIpCode = (countries: Country[], geoIpCode: string): Country[] => {
    return countries.filter(country => {
        return country.geoIpCodes.map(code => code.toLocaleLowerCase()).includes(geoIpCode.toLocaleLowerCase());
    });
};

export const filterCountriesByBrowserLanguage = (countries: Country[], languageCode: string): Country[] => {
    return countries.filter(country => {
        return country.browserLanguageCodes.map(language => language.toLocaleLowerCase()).includes(languageCode.toLocaleLowerCase());
    });
};

export const filterCountriesByTimezone = (countries: Country[], utcTimezone: number): Country[] => {
    return countries.filter(country => {
        return country.isUTCTimezoneInRange(utcTimezone);
    });
};
